<template>
  <template v-if="data.length == 0 && reservation">
    <div class="row">
       <div class="col-sm-3"></div>
      <div v-if="reservation" class="col-sm-6">
        <p class="text-center">
          <small
            >You have been invited by
            <strong>{{ reservation.invited_by }}</strong> to attend ARC LE SALON
            on <strong>{{ reservation.invitation_date_label }}. </strong></small
          >
        </p>
      </div>
      <div class="col-sm-3"></div>
    </div>
    <div class="row">
      <div class="col-sm-3"></div>
      <div class="col-sm-6">
        <template v-if="reservation.matchesHgUser">
          <RegisteredUser @signupEvent="displayForm" v-bind:guest="guest_id" />
        </template>
        <template v-if="showForm || !reservation.matchesHgUser">
          <p class="text-center">
            <small>
              <strong
                >Please complete the form to get your guest pass.</strong
              ></small
            >
          </p>

          <Form
            @submit="handleRegister"
            :validation-schema="schema"
            id="signup_form"
          >
            <div class="form-group">
              <label for="title" class="form-control-sm">Title</label>
              <Field
                name="title"
                ref="title"
                as="select"
                class="form-control form-select-sm"
              >
                <option value="" disabled selected>Please select</option>
                <template v-for="title in titles" :key="title.code">
                  <option :value="title.code">{{ title.label }}</option>
                </template>
              </Field>
              <ErrorMessage name="title" class="error-feedback" />
            </div>
            <div class="form-group">
              <label for="firstname" class="form-control-sm">First Name</label>
              <Field
                name="firstname"
                type="text"
                class="form-control form-control-sm"
              />
              <ErrorMessage name="firstname" class="error-feedback" />
            </div>
            <div class="form-group">
              <label for="lastname" class="form-control-sm">Last Name</label>
              <Field
                name="lastname"
                type="text"
                class="form-control form-control-sm"
              />
              <ErrorMessage name="lastname" class="error-feedback" />
            </div>
            <div class="form-group">
              <label for="file" class="form-control-sm">Photo</label>
              <p class="text-center">
                <small
                  >Your photo should be of your face, similar to a passport
                  picture.</small
                >
              </p>

              <div>
                <Field
                  name="file"
                  type="file"
                  class="form-control form-control-sm"
                  @change="onFileChange"
                />

                <ErrorMessage name="file" class="error-feedback" />
              </div>

              <template v-if="url">
                <div class="form-group" id="preview">
                  <label class="form-control-sm"
                    >Photo Preview: The preview may show a resized photo, just
                    to make it easier to check.
                  </label>
                  <p class="text-center">
                    <small
                      >Please check your photo, if it appears rotated then
                      change it.</small
                    >
                  </p>
                  <img v-if="url" :src="url" class="scale" />
                </div>
              </template>

              <div class="form-group form-check mt-3">
                <Field
                  name="acceptTerms"
                  type="checkbox"
                  id="acceptTerms"
                  :value="true"
                  class="form-check-input"
                />
                <label
                  for="acceptTerms"
                  class="form-check-label form-control-sm"
                  >Accept
                  <a
                    href="https://www.huntergold.com/terms/"
                    class="card-link text-dark"
                  >
                    Terms &amp; Conditions</a
                  >
                </label>
                <ErrorMessage name="acceptTerms" class="error-feedback" />
              </div>
              <div class="form-group form-check">
                <Field
                  name="acceptPrivacy"
                  type="checkbox"
                  id="acceptPrivacy"
                  :value="true"
                  class="form-check-input"
                />
                <label
                  for="acceptPrivacy"
                  class="form-check-label form-control-sm"
                  >Accept
                  <a
                    href="https://www.huntergold.com/privacypolicy/"
                    class="card-link text-dark"
                    >Privacy Policy</a
                  >
                </label>
                <ErrorMessage name="acceptPrivacy" class="error-feedback" />
                <!--<div class="invalid-feedback">{{ errors.acceptTerms }}</div>-->
              </div>

              <!--<Field
            name="photo"
            type="file"
            class="form-control"
            id="photo_file"
            ref="photo_file"
          />
          <ErrorMessage name="photo" class="error-feedback" />-->
            </div>
            
            <template v-if="showSubmit">
            <div class="form-group text-center mt-2">
              <button
                class="btn btn-dark btn-block text-white"
                type="submit"
                @click="submit"
              >
                <span
                  v-show="loading"
                  class="spinner-border spinner-border-sm"
                ></span>

                <span> Submit </span>
                <font-awesome-icon icon="chevron-right" />
              </button>
            </div>
            </template>

            <div class="form-group">
              <div v-if="message" class="alert alert-danger" role="alert">
                {{ message }}
              </div>
            </div>
          </Form>
        </template>
      </div>
      <div class="col-sm-3"></div>
    </div>
  </template>

  <div class="row" v-if="data">
    <div class="col-sm-3"></div>
    <div class="col-sm-6 text-center">
      <template v-if="data.length > 0">
        <p class="text-success">
          <small
            >Download/Screenshot your Guest Pass, as it will not be accessible
            again. <strong>Must be shown at the venue.</strong></small>
        </p>
        <GuestPass v-bind:profile="data[0]" />
      </template>
    </div>
    <div class="col-sm-3"></div>
  </div>
  <div class="row" v-if="reservation == null">
    <div class="col-sm-3"></div>
    <div class="col-sm-6 mt-3 text-center">
      <div v-if="message" class="alert alert-danger" role="alert">
        {{ message }}
      </div>
    </div>
    <div class="col-sm-3"></div>
  </div>

  <div class="row" v-if="found && found.length > 0">
    <div class="col-sm-3"></div>
    <div class="col-sm-6">
      <RegisteredUser @signupEvent="displayForm2" v-bind:guest="guest_id" />
    </div>
    <div class="col-sm-3"></div>
  </div>
</template>


<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import GuestPass from "./GuestPass";
import RegisteredUser from "./RegisteredUser";
import VenueService from "../services/venue.service";
import GuestService from "../services/guest.service";
import NotFound from './NotFound.vue'
import * as yup from "yup";
import $ from "jquery";

export default {
  name: "SignUp",

  props: ["id"],

  components: {
    Form,
    Field,
    ErrorMessage,
    GuestPass,
    RegisteredUser,
    NotFound
  },

  mounted() {  
    // Check the ID is a number
    if(Number(this.id) && Number(this.id) % 1 === 0){ 
      this.loadReservation();
      this.loadTitles();
    } else {
      
      this.$router.push({ name: 'NotFound', params: { catchAll:this.id } })
    }
  },
  data() {
    const schema = yup.object().shape({
      title: yup.string().required("Please select a title"),
      firstname: yup.string().required("First name is required"),
      lastname: yup.string().required("Last name is required"),
      acceptTerms: yup.bool().required("Accept T&Cs is required"),
      acceptPrivacy: yup.bool().required("Accept Privacy Policy is required"),
      file: yup.array().required("Your photo is required"),
      //photo: yup.string().required("Photo is required"),
      // id: yup.string(),
      //id_type: yup.string().when("id", {
      //is: (id) => id !== undefined && id.length > 0,
      // then: yup.string().required("Please select the Photo ID type"),
      //}),
    });

    return {
      loading: false,
      message: "",
      data: [],
      found: [],
      titles: [],
      schema,
      guest_id: this.id,
      reservation: null,
      imagesArray: null,
      img: null,
      confirmHg: false,
      showForm: false,
      showSubmit: true,
      url: null,
      //jwt: "eyJ0eXAiOiAiSldUIiwgImFsZyI6ICJSUzI1NiIsICJraWQiOiAiYTViYWE0NGUyNjdmN2I1ZmQ4NGU5NWNkZDEwYmZmMzNjY2Q3MDU1MCJ9.eyJpc3MiOiAiY3JlYXRlLXBhc3NAaHVudGVyLWdvbGQtZ3Vlc3QtcGFzcy5pYW0uZ3NlcnZpY2VhY2NvdW50LmNvbSIsICJhdWQiOiAiZ29vZ2xlIiwgInR5cCI6ICJzYXZldG9hbmRyb2lkcGF5IiwgImlhdCI6IDE2NTI4NjU3NDQsICJwYXlsb2FkIjogeyJldmVudFRpY2tldE9iamVjdHMiOiBbeyJpZCI6ICIzMzg4MDAwMDAwMDIyMTIxMjI0LkdVRVNUX1BBU1NfT0JKRUNUXzRkM2U4YzVlLTQxYzMtNDVhNC1hNGUyLTAwNGQ3MGE3ZTgwZCJ9XX0sICJvcmlnaW5zIjogWyJodHRwOi8vbG9jYWxob3N0OjgwMDAiLCAiaHR0cDovL2xvY2FsaG9zdDo4MDgwIl19.itIIO2lSYqCqnuU6AG-SmZrF6nyFAp8DCg00lk_cczh_0V_4pmqNFS5dwn--O4fM5dTrt7uTvIEYIs4wJadH9nLhZkTmg74HG_J7RAxf65NL-y8rqqMPELS9f0gM3ELx3JjmL9OVrak8jx_5HL3I5_G20pvMXhI34Df0ZfhpZZ680EqIP2M6xDDS_hUiUFtczpBmtpR2fZ39Ore9jKl5kqQQCiV9Wf9SP6wC1ITwhulTkggaJorpZnBYr0HVRq6dnXMYt2yud6XCD4b6AkyUa1qvZyQ934KbeiL__NN9VxIUz1TcMlhAlCqAWs_C5Vt0cNoucMBQCqrQHWEyb-pCUw"
    };
  },

  methods: {
    displayForm(value) {
      // Display the sign up form or not
      this.showForm = value;
      this.reservation.matchesHgUser = false;
    },

    displayForm2(isNotRegistered) {
      //The sign up form is visible at this point
      this.reservation.matchesHgUser = false;
      this.showSubmit = false; //hide the sign up form's submit button

      // User is not registered
      if (isNotRegistered){      
          this.signUp();       
      }
    },


    loadReservation() {
      GuestService.getReservation(this.guest_id).then(
        (response) => {
          this.reservation = response;
        },
        (error) => {
          this.loading = false;
          this.message = error.response.data.detail;
        }
      );
    },

    loadTitles() {
      VenueService.getTitles().then(
        (response) => {
          this.titles = response;
        },
        (error) => {
          this.loading = false;
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
    },

    onFileChange(event) {
      this.imagesArray = event.target.files[0];
      this.url = URL.createObjectURL(event.target.files[0]);
      this.createBase64Image(this.imagesArray);
    },

    createBase64Image(fileObj) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.img = e.target.result;
      };
      reader.readAsDataURL(fileObj);
    },

    handleRegister(user) {
      var self = this;
      this.loading = true;

      if (this.img !== null) {
        var photoBase64 = this.img.split(",")[1];
        user.photo64 = photoBase64;
      }

      user.title = parseInt(user.title);

      GuestService.findByName(user).then(
        //UserService.signUp(user).then(
        (response) => {
          this.message = "";
          this.loading = false;
          self.found = response;
          //this.resetForm();
          //self.data.push(response);
        },
        (error) => {
          this.loading = false;
          this.message = "";

          if (error.response.status === 404) {
            // Sign Up, no matches found
            self.signUp();
          } else {
            this.message =
              (error.response &&
                error.response.data &&
                error.response.data.detail) ||
              error.response.data.detail ||
              error.toString();
          }
        }
      );
    },
    signUp() {
      this.found = [];

      let form = $("#signup_form")[0];
      let user = {};
      var self = this;
      this.loading = true;
      user.firstname = this.capitalizeFirstLetter(form.firstname.value);
      user.lastname = this.capitalizeFirstLetter(form.lastname.value);
      user.role_start = this.reservation.invitation_date_value;
      user.invited_by = this.reservation.invited_by_id;
      user.guest_id = this.guest_id;//this.id;

      // Photo
      if (this.img !== null) {
        var photoBase64 = this.img.split(",")[1]; //form.photo.value.split(",")[1];
        user.photo64 = photoBase64;
      }

      // Title
      user.title = parseInt(form.title.value);

      GuestService.signUp(user).then(
        (response) => {
          this.message = "";
          this.loading = false;
          this.resetForm();
          self.data.push(response);
        },
        (error) => {
          this.loading = false;
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.detail) ||
            error.response.data.detail ||
            error.toString();
        }
      );
    },
    resetForm() {
      $("#signup_form")[0].reset();
      this.imagesArray = null;
      this.img = null;
    },
    capitalizeFirstLetter(name) {
      return name.charAt(0).toUpperCase() + name.slice(1);
    },
  },
};
</script>
 
<style scoped>
.btn:focus {
  outline: none;
  box-shadow: none;
}

button {
  margin-top: 10px;
}
label {
  display: block;
  margin-top: 10px;
}

.register {
  background-color: #a18140;
  margin: 10px;
  border: none !important;
  box-shadow: none !important;
  outline: 0 none !important;
}

.error-feedback {
  color: red;
}

label {
  font-weight: bold;
  margin: 5px;
}

p {
  text-indent: 5px;
}

.signup_title {
  margin-top: 10px;
  font-weight: bold;
  color: green;
}

.scale {
  width: 300px;
  height: 300px;
  object-fit: scale-down;
}
</style>